export default __webpack_public_path__ + "static/vasyl-kostin-76743322ce3b92565c0a6d9ece68a72d.jpeg";